export const colors = {
  beige: '#F5F1E8',
  black: '#000000',
  red: '#C1121F',
  blue: '#003049'
};
